<!--ダッシュボードにいるグラフのテンプレ -->
<template>
    <div class="dashboard-content">
        <v-row>
            <v-col class="pt-0 pb-0" cols="9">
                <div class="graph-title">
                    <!-- {{tmpGraphTitle}} -->
                    <v-text-field ref="title" v-model="tmpGraphTitle" hide-details class="pt-0 pb-0 graph-title-text"
                        :readonly="!open" @change="changeGraphTitle" :height="titleHeight"></v-text-field>
                </div>
            </v-col>
            <!-- button -->
            <v-col class="pt-0 pb-0" cols="3">
                <div class="buttons" :class="{ hidden: open }">
                    <v-row justify="center">
                        <v-btn text icon color="indigo" @click.stop="openDownloadDialog = true" @click="handlePrint">
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                        <v-dialog v-model="openDownloadDialog" max-width="600px">
                            <download :img="tmpImageData" :title="tmpGraphTitle" :description="tmpGraphDescription"
                                :openDownloadDialog="openDownloadDialog" :imgWidth="tmpGraphW"
                                @close="closeDownloadModal" />
                        </v-dialog>
                    </v-row>
                </div>
                <div class="buttons" :class="{ hidden: !open }">
                    <v-btn text icon color="indigo" @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>

        <div class="graph-object">
            <!-- <DocumentFrequency
        v-if="graphType === 'documentFrequency'"
        :width="Math.min(this.tmpGraphW, this.tmpGraphH)"
        :height="Math.min(this.tmpGraphW, this.tmpGraphH)"
        :styles="graphStyles"
      />

      <ApprovalDocumentTimeAverage
        v-else-if="graphType === 'approvalDocumentTimeAverage'"
        ref="object"
        :width="tmpGraphW"
        :height="tmpGraphH"
        :styles="graphStyles"
      />

      <ApprovalTimeAverage
        v-else-if="graphType === 'approvalTimeAverage'"
        ref="object"
        :width="tmpGraphW"
        :height="tmpGraphH"
        :styles="graphStyles"
      />
      <DocumentRejectionRate
        v-else-if="graphType === 'documentRejectionRate'"
        ref="object"
        :width="tmpGraphW"
        :height="tmpGraphH"
        :styles="graphStyles"
      />
      <UserRejectionRate
        v-else-if="graphType === 'userRejectionRate'"
        ref="object"
        :width="tmpGraphW"
        :height="tmpGraphH"
        :styles="graphStyles"
      />
      <DeviceFrequency
        v-else-if="graphType === 'deviceFrequency'"
        :width="Math.min(this.tmpGraphW, this.tmpGraphH)"
        :height="Math.min(this.tmpGraphW, this.tmpGraphH)"
        :styles="graphStyles"
      />
      <ApplyDocumentNumber
        v-else-if="graphType === 'applyDocumentNumber'"
        :width="tmpGraphW"
        :height="tmpGraphH"
        :style="numberStyle"
      />
      <Chart
        v-else
        :width="tmpGraphW"
        :height="tmpGraphH"
        :styles="graphStyles"
      /> -->
            <!-- グラフ描画はGraphObjectコンポーネントに統一 -->
            <GraphObject :graphType="graphType" :width="tmpGraphW" :height="tmpGraphH"></GraphObject>
        </div>
        <!--<div class="graph-index">
      <v-btn ref="dataIndex">

      </v-btn>
    </div>-->
        <div class="graph-description">
            <v-textarea ref="description" rows="1" :readonly="!open" v-model="tmpGraphDescription" hide-details
                @change="changeGraphDescription" no-resize></v-textarea>
        </div>
        <!-- <div class="graph-description-editable" v-show="open">
      <v-textarea
        rows="1"
        auto-grow
        v-model="tmpGraphDescription"
        hide-details
        @change="changeGraphDescription"
      ></v-textarea>
                  </div>-->
    </div>
</template>

<script>
// import Chart from "../../Graphs/Category2/ChartSample";
// import DocumentFrequency from "../../Graphs/Category1/DocumentFrequency";
// import ApprovalDocumentTimeAverage from "../../Graphs/Category1/ApprovalDocumentTimeAverage";
// import ApprovalTimeAverage from "../../Graphs/Category1/ApprovalTimeAverage";
// import DocumentRejectionRate from "../../Graphs/Category1/DocumentRejectionRate";
// import UserRejectionRate from "../../Graphs/Category1/UserRejectionRate";
// import DeviceFrequency from "../../Graphs/Category1/DeviceFrequency";
// import ApplyDocumentNumber from "../../Graphs/Category1/ApplyDocumentNumber";
import Download from "./Download";
import GraphObject from "../../parts/GraphObject";
export default {
    props: [
        "graphTitle",
        "graphType",
        "graphDescription",
        "index",
        "open",
        "w",
        "h",
    ],
    data: function () {
        return {
            tmpGraphTitle: this.graphTitle,
            tmpGraphDescription: this.graphDescription,
            //w,hはダッシュボードに用いているマス数(index.vue参照)
            //w,hに幅とマージン(150px,10px)をかけ、最外端マスのマージン(10px)を引く
            //また、ダッシュボードの外側に3pxのボーダーが引かれているので、その分の6pxを引く
            // テーブルなど.mdも参照
            //以下tmpGraphW,tmpGraphHの計算は同様
            tmpGraphW: this.w * 160 - 10 - 6,
            tmpGraphH: this.h * 160 - 10 - 102 - 6,
            tmpGraphMaxWH: Math.min(this.tmpGraphW, this.tmpGraphH),
            openDownloadDialog: false,
            showTitle: "",
            showDescription: "",
            tmpImageData: "",
            titleHeight: 32,
            descriptionHeight: 70,
        };
    },
    computed: {
        // グラフの描画サイズ算出プロパティ、GraphObjectへ移行
        // graphStyles() {
        //   if (
        //     this.graphType == "documentFrequency" ||
        //     this.graphType == "deviceFrequency"
        //   ) {
        //     var minWH = Math.min(this.tmpGraphW, this.tmpGraphH);
        //     return {
        //       height: `${minWH}px`,
        //       width: `${minWH}px`,
        //       position: "relative",
        //     };
        //   } else if (this.graphType == "applyDocumentNumber") {
        //     return {
        //       height: `${this.tmpGraphH}px`,
        //       width: `${this.tmpGraphW}px`,
        //       fontSize: `${this.tmpGraphH * this.tmpGraphW * 0.001}px`,
        //       justifyContent: "center",
        //       alignItems: "center",
        //       display: "flex",
        //     };
        //   }else{
        //     return {
        //       height: `${this.tmpGraphH}px`,
        //       width: `${this.tmpGraphW}px`,
        //       position: "relative",
        //     };
        //   }
        // },
        // numberStyle() {
        //   return {
        //     height: `${this.tmpGraphH}px`,
        //     width: `${this.tmpGraphW}px`,
        //     display: "flex",
        //     "font-size": `${this.tmpGraphH * this.tmpGraphW * 0.001}px`,
        //     "justify-content": "center",
        //     "align-items": "center",
        //   };
        // },
    },
    mounted() {
        // TODO 画面を読み込みが終了してから実行するようにしたい
        setTimeout(() => {
            this.updateDescriptionHeight();
        }, 2000);
    },
    updated() {
        // TODO 画面を読み込みが終了してから実行するようにしたい
        this.$nextTick();
        this.updateDescriptionHeight();
    },
    watch: {
        graphTitle(val) {
            if (val) {
                this.tmpGraphTitle = this.graphTitle;
            }
        },
        graphDescription(val) {
            if (val) {
                this.tmpGraphDescription = this.graphDescription;
                this.updateDescriptionHeight();
            }
        },
        w(val) {
            if (val) {
                this.tmpGraphW = this.w * 160 - 10 - 6;
            }
        },
        h(val) {
            if (val) {
                this.updateDescriptionHeight();
            }
        },
    },
    components: {
        // Chart,
        // DocumentFrequency,
        // ApprovalDocumentTimeAverage,
        // ApprovalTimeAverage,
        // DocumentRejectionRate,
        // UserRejectionRate,
        // DeviceFrequency,
        // ApplyDocumentNumber,
        Download,
        GraphObject
    },
    methods: {
        close: function () {
            this.$emit("close", { index: this.index });
        },
        changeGraphTitle: function () {
            this.$emit("changeGraphTitle", {
                index: this.index,
                title: this.tmpGraphTitle,
            });
        },
        changeGraphDescription: function () {
            this.$emit("changeGraphDescription", {
                index: this.index,
                description: this.tmpGraphDescription,
            });
            // 変更後のテキストエリアの高さ
            this.updateDescriptionHeight();
        },
        updateDescriptionHeight() {
            // 説明文の表示に一時的に制限をかけることでグラフ本体や他グラフへの影響をなくしています。(20230913)
            // this.descriptionHeight = Number(
            //     this.$refs.description.$refs.input.style.height.replace("px", "")
            // );
            this.tmpGraphH =
                (this.h * 160 - 10 - 6) - (this.titleHeight + 32 + 22);
            this.$store.dispatch("downloadsize/SET_DOWNLOAD_SIZE_INFO", {
                index: this.index,
                width: this.tmpGraphW,
                height: this.tmpGraphH,
            });
        },
        handlePrint() {
            const canvasEle = this.$el.querySelector("canvas");
            this.tmpImageData = canvasEle.toDataURL("image/png");
        },
        closeDownloadModal() {
            this.openDownloadDialog = false;
        },
    },
};
</script>

<style scoped>
.graph-title .graph-title-editable {
    font-size: 20px;
}

.graph-title {
    border-left: solid 5px #7e6990;
    font-weight: bold;
}

.graph-title-text {
    margin-left: 5px;
    border: none;
}

.graph-description .graph-description-editable {
    font-size: 10px;
}

.v-textarea >>> textarea {
    height: 32px;
}

.buttons {
    text-align: right;
}

.hidden {
    display: none;
}
</style>
